import React from 'react';
import {ApolloProvider} from 'react-apollo';
import configureApolloClient from './client';

export const wrapWithApolloProvider = ({element}, {sitename}) => (
    <ApolloProvider client={configureApolloClient(sitename)}>
        {element}
    </ApolloProvider>
);
